module.exports = __webpack_public_path__ + "../front/img/568_3_skuffer+hylder.ca0c836d.svg";